import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-file-upload-chip',
  standalone: true,
  imports: [MatIconModule,CommonModule],
  templateUrl: './file-upload-chip.component.html',
  styleUrl: './file-upload-chip.component.css'
})
export class FileUploadChipComponent {
  selectedFileName: string | null = null;

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedFileName = input.files[0].name;
    }
  }
}
